import React from 'react';
import { guidesData } from '../data/content';
import Button from './ui/Button';

const GuideDetails = () => {
  return (
    <section className="py-24 bg-vintage-white">
      <div className="max-w-3xl mx-auto px-6 lg:px-8">
        {guidesData.map((guide, index) => (
          <article 
            key={guide.id} 
            id={guide.id} 
            className={`scroll-mt-24 ${index !== guidesData.length - 1 ? 'mb-24 pb-24 border-b border-warm-stone/30' : ''}`}
          >
            <h2 className="text-3xl md:text-4xl font-serif text-deep-charcoal mb-8">
              {guide.title.replace(/^\d+\.\s*/, '')}
            </h2>
            
            <div className="space-y-6 text-lg text-deep-charcoal/80 font-light leading-relaxed mb-10">
              {guide.content.paragraphs.map((p, i) => (
                <p key={i}>{p}</p>
              ))}
            </div>

            {/* Contextual Image for certain guides to improve engagement */}
            {guide.id === 'guide-3' && (
              <div className="mb-10 aspect-video rounded-xl overflow-hidden shadow-sm border border-warm-stone/30">
                <img 
                  src="https://images-pw.pixieset.com/elementfield/6GYLLro/0648-dd0762c0-1000.jpg" 
                  alt="Golden hour Spanish Revival architecture at Padua Weddings"
                  className="w-full h-full object-cover"
                />
              </div>
            )}

            <div className="bg-aged-ivory p-8 rounded-xl border border-warm-stone/40 mb-10">
              <h4 className="text-xs font-bold uppercase tracking-widest text-olive-grove mb-3">
                Key Takeaway
              </h4>
              <p className="text-xl font-serif text-deep-charcoal">
                {guide.content.keyTakeaway}
              </p>
            </div>

            <div className="mb-12">
              <h4 className="text-lg font-medium text-deep-charcoal mb-4">Important Considerations:</h4>
              <ul className="space-y-3">
                {guide.content.bullets.map((bullet, i) => (
                  <li key={i} className="flex items-start">
                    <span className="text-estate-bronze mr-3 mt-1">•</span>
                    <span className="text-deep-charcoal/80 font-light">{bullet}</span>
                  </li>
                ))}
              </ul>
            </div>

            <div className="text-center pt-4">
              <p className="text-sm text-deep-charcoal/60 mb-4 italic">
                Ready to experience the atmosphere for yourself?
              </p>
              <Button href="https://tour.paduaweddings.com" variant="outline">
                Book a Private Tour
              </Button>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};

export default GuideDetails;